import { __awaiter } from "tslib";
import { getConfig } from '@local/app-config';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getCombinedToken as getAccessToken } from '../../store/sessionStorageHelpers/accessTokenHelper/accessTokenHelper';
const dynamicBaseQuery = (args, WebApi, extraOptions) => __awaiter(void 0, void 0, void 0, function* () {
    const baseUrl = getConfig().identity_url;
    const rawBaseQuery = fetchBaseQuery({
        baseUrl,
        prepareHeaders: (headers) => {
            var _a;
            const token = (_a = getAccessToken()) === null || _a === void 0 ? void 0 : _a.access_token;
            headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    });
    return rawBaseQuery(args, WebApi, extraOptions);
});
export const UserApiClient = createApi({
    reducerPath: 'userApi',
    baseQuery: dynamicBaseQuery,
    endpoints: () => ({}),
});
//# sourceMappingURL=UserApiClient.js.map